import React, { useEffect, useState } from 'react';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import '../../styles/ComputerScienceDepartment.css';
import ProfIcon from '../../images/comp-lab.jpg'; // Add a relevant icon/image

const computerScienceInfo = {
  established: 2022,
  intake: 80,
  degrees: ['B.Sc. (Computer Science)'],
  eligibility: '12th pass with Mathematics',
  program: `
Three‑year program combining programming, data structures, databases, web dev, and allied sciences.
Labs, projects, and industry‑aligned curriculum based on NEP 2020.`,
};

const facultyList = [
  { name: 'Prof. Gorde Rupali Gorkshnath', role: 'H.O.D', qual: 'M.C.S.' },
  { name: 'Prof. Surose Nikita Pradip', role: 'Asst. Prof.', qual: 'M.C.S.' },
];

const ComputerScience = () => {
  const [fade, setFade] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
    setTimeout(() => setFade(true), 100);
  }, []);

  return (
    <>
      <Navbar />
      <section className='section-wrapper-no-text-align'>
      <div className={`cs-container ${fade ? 'fade-in' : ''}`}>
        <section className="cs-header">
          <h4>Shri Mulikadevi Mahavidyalaya, Nighoj</h4>
          <h2>Department of Computer Science</h2>
          <p>
            Established in {computerScienceInfo.established}, our B.Sc. (Computer Science) program offers a comprehensive curriculum combining theory and practical learning in programming, databases, web development, and allied sciences.
          </p>
        </section>

        <section className="cs-details">
          <div className="cs-info">
            <p><strong>Intake Capacity:</strong> {computerScienceInfo.intake}</p>
            <p><strong>Eligibility:</strong> {computerScienceInfo.eligibility}</p>
            <p className="cs-program">{computerScienceInfo.program}</p>
            <a href="/departments/computer-science/curriculum" className="learn-btn">View Curriculum</a>
          </div>
          <div className="cs-image">
            <img src={ProfIcon} alt="Computer Lab" />
          </div>
        </section>

        <section className="cs-faculty">
          <h3>Faculty Members</h3>
          <div className="faculty-cards">
            {facultyList.map((f, idx) => (
              <div key={idx} className="faculty-card animate-card">
                <h4>{f.name}</h4>
                <p>{f.role}</p>
                <p>{f.qual}</p>
              </div>
            ))}
          </div>
        </section>
      </div>
      </section>
      <Footer />
    </>
  );
};

export default ComputerScience;
